export default __webpack_public_path__ + "static/media/arrow-right.3003acc4.svg";